module.exports = __webpack_public_path__ + "media/images/it/icons/bullseye-bccea7719164f7970d673ca65ba19cd6.svg";